import React from "react";
import InputField from "../../FormFields/InputField";

const MessageA14 = (props) => {
  return <InputField {...props} />;
};

export default MessageA14;
